import React, { Component } from 'react';
import { Row, Col, Panel, Modal, Button } from 'react-bootstrap'
import { connect } from 'react-redux'
import { Field, reduxForm, reset } from "redux-form"
import NavHeader from './navheader'
import { fetchEditUserInfoFormInitial, updateAccount, showButtonUserInfoPage } from '../actions'
import { } from '../utils'
import _ from 'lodash'
import axios from 'axios'
import SubMenu from './submenu'
import Footer from './footer'
import ComponentAddress from './componentAddressNew'
import RendererWithGoogleMap from './google_map'
import Geosuggest from 'react-geosuggest';
class PageUserInfo extends Component {
    componentWillMount() {
        if (localStorage.getItem('user') != null) {
            this.setState({ isLogin: true })
        } else {
            this.props.history.push('/login')
        }
        window.scrollTo(0, 0)
    }
    componentWillUnmount() {
        this.props.showButtonUserInfoPage('')
    }
    state = {
        user: JSON.parse(localStorage.getItem('user')),
        editInfo: false,
        editAddress: false,
        isLogin: false,
        showModal: false,
        new_address: '',
        showgeoaddress: "",
        lat: 0,
        lng: 0,
        deflat: 0,
        deflng: 0,
        allowgetlocation: false,
        province: '',
        amphoe: '',
        district: '',
        zipcode: ''
    }
    setRegisterPageState(values) {
        this.setState({ ...values })
    }
    onLogout() {
        localStorage.removeItem('user')
        this.props.history.push('/login')
    }
    onSubmit(values) {
        let address = JSON.parse(JSON.stringify(values))
        delete address['email']; delete address['lastname']; delete address['name'];
        delete address['password']; delete address['phone_number']; delete address['token'];
        delete address['address'];
        address['latitude'] = this.state.lat; address['longitude'] = this.state.lng;
        let new_user = {
            email: values.email, lastname: values.lastname, name: values.name,
            phone_number: values.phone_number, token: values.token
        }
        if (this.state.zipcode) {
            address['province'] = this.state.province
            address['area'] = this.state.amphoe
            address['district'] = this.state.district
            address['zip_code'] = this.state.zipcode
        }
        new_user['address'] = {}
        new_user['address']['address1'] = address

        this.props.updateAccount(new_user, this.state.user.token)
        localStorage.setItem('user', JSON.stringify(new_user))
        let newState = { editInfo: false, editAddress: false, user: new_user }
        this.setState({ ...newState })
        this.props.dispatch(reset('EditUserInfoForm'))
    }
    onFinishAddAddress() {
        let values = this.state.user
        let address_key = this.state.new_address
        address_key = address_key.split(/[\s,/]+/)
        address_key = address_key[0]
        values['address'][address_key] = this.state.new_address
        this.props.updateAccount(values, this.state.user.token)
        localStorage.setItem('user', JSON.stringify(values))
        this.closeModal()
    }
    textareaHandler(textarea) {
        var value = textarea.target.value
        this.setState({ new_address: value })
    }
    onAddAddress() {
        this.setState({ showModal: true })
    }
    closeModal() {
        let newState = { showModal: false, new_address: '' }
        this.setState({ ...newState })
    }
    onEditInfo() {
        let lat, lng
        if (this.state.user.address) {
            lat = this.state.user.address.address1.latitude
            lng = this.state.user.address.address1.longitude
        } else {
            lat = ''
            lng = ''
        }
        this.props.fetchEditUserInfoFormInitial(this.state.user)
        this.setState({ lat: lat, lng: lng, editInfo: true })
    }
    onEditAddress() {
        let lat = this.state.user.address.address1.latitude
        let lng = this.state.user.address.address1.longitude
        this.props.fetchEditUserInfoFormInitial(this.state.user)
        this.setState({ lat: lat, lng: lng, deflat: lat, deflng: lng, editAddress: true })
    }
    renderField(field) {
        const { meta: { touched, error } } = field;
        const className = `form-group ${touched && error ? "has-danger" : ""}`;
        return (
            <div className={className}>
                <label>{field.placeholder}: </label>
                <input placeholder={field.placeholder} className="form-control" type={field.type} {...field.input} />
                <div className="text-help">
                    {touched ? error : ""}
                </div>
            </div>
        )
    }
    renderTextAreaField(field) {
        const { meta: { touched, error } } = field;
        const className = `form-group ${touched && error ? "has-danger" : ""}`;
        return (
            <div className={className}>
                <textarea placeholder={field.placeholder} className="form-control" rows='2' {...field.input} />
                <div className="text-help">
                    {touched ? error : ""}
                </div>
            </div>
        )
    }
    renderInfo() {
        let display = this.state.editAddress ? 'none' : ''
        return (
            <Panel>
                <Row>
                    <div style={{ display: display }}><h4 style={{ textAlign: 'left', display: 'inline-block' }}><strong>ข้อมูลทั่วไป</strong></h4><div className='pull-right' style={{ display: 'inline-block', paddingTop: 10, cursor: 'pointer' }} onClick={() => this.onEditInfo()}><a>แก้ไข</a></div></div>
                </Row>
                <Row>
                    <Col md={1} sm={12} xs={12} />
                    <Col md={4} sm={12} xs={12}>
                        <h5><strong>ชื่อ-นามสกุล</strong></h5>
                    </Col>
                    <Col md={4} sm={12} xs={12}>
                        {this.state.user.name + ' ' + this.state.user.lastname}
                    </Col>
                </Row>
                <Row>
                    <Col md={1} sm={12} xs={12} />
                    <Col md={4} sm={12} xs={12}>
                        <h5><strong>โทรศัพท์</strong></h5>
                    </Col>
                    <Col md={4} sm={12} xs={12}>
                        {this.state.user.phone_number}
                    </Col>
                </Row>
                <Row>
                    <Col md={1} sm={12} xs={12} />
                    <Col md={4} sm={12} xs={12}>
                        <h5><strong>อีเมล</strong></h5>
                    </Col>
                    <Col md={4} sm={12} xs={12}>
                        {this.state.user.email ? this.state.user.email : ''}
                    </Col>
                </Row>
                <a style={{ float: 'right' }} href={'/password'}>เปลี่ยนรหัสผ่าน</a>
            </Panel>
        )
    }
    renderEditInfo() {
        const { handleSubmit } = this.props
        return (
            <Panel>
                <div style={{ marginLeft: 10, marginRight: 10 }}>
                    <form onSubmit={handleSubmit(this.onSubmit.bind(this))} >
                        <Row>
                            <Field
                                placeholder="ชื่อ"
                                name="name"
                                type='text'
                                component={this.renderField}
                            />
                            <Field
                                placeholder="นามสกุล"
                                name="lastname"
                                type='text'
                                component={this.renderField}
                            />
                            <Field
                                placeholder="อีเมล (ถ้ามี)"
                                name="email"
                                type='text'
                                component={this.renderField}
                            />
                            <Field
                                placeholder="เบอร์โทรศัพท์"
                                name="phone_number"
                                type='text'
                                component={this.renderField}
                            />
                        </Row>
                        <Row>
                            <button style={{ marginRight: 10, width: 150, height: 35 }} className='btn btn-danger pull-right' onClick={() => { this.setState({ editInfo: false }); this.props.dispatch(reset('EditUserInfoForm')) }}>ยกเลิก</button>
                            <button type='submit' style={{ marginRight: 10, width: 150, height: 35 }} className='btn btn-success pull-right' >บันทึกการเปลี่ยนแปลง</button>
                        </Row>
                    </form>
                </div>
            </Panel>
        )
    }
    renderAddress() {
        let display = this.state.editInfo ? 'none' : ''
        return (
            <Panel>
                <Row>
                    <div style={{ display: display }}><h4 style={{ textAlign: 'left', display: 'inline-block' }}><strong>ที่อยู่</strong></h4><div className='pull-right' style={{ display: 'inline-block', paddingTop: 10, cursor: 'pointer' }} onClick={() => { this.state.user.address ? this.onEditAddress() : this.props.history.push('/add_address') }}><a>แก้ไข</a></div></div>
                </Row>
                {this.renderAddressItem()}
            </Panel>
        )
    }
    renderAddressItem() {
        let id = 0
        let arrayAddress1 = []
        let arrayAddress2 = []
        let arrayAddress3 = []
        let arrayAddress4 = []
        return _.map(this.state.user.address, address => {

            address.building ? arrayAddress1.push(<div key={id++} style={{ display: 'inline-block' }}><strong>อาคาร/หมู่บ้าน:</strong> {address['building']}&nbsp;</div>) : ''
            address.room_number ? arrayAddress1.push(<div key={id++} style={{ display: 'inline-block' }}><strong>ห้อง:</strong> {address['room_number']}&nbsp;</div>) : ''
            address.floor ? arrayAddress1.push(<div key={id++} style={{ display: 'inline-block' }}><strong>ชั้น:</strong> {address['floor']}&nbsp;</div>) : ''
            arrayAddress2.push(<div key={id++} style={{ display: 'inline-block' }}><strong>เลขที่:</strong> {address['house_number']}&nbsp;</div>)
            address.residential_type ? arrayAddress2.push(<div key={id++} style={{ display: 'inline-block' }}><strong>ชื่ออาคาร/หมู่บ้าน:</strong> {address.residential_type}&nbsp;</div>) : ''
            address.road ? arrayAddress2.push(<div key={id++} style={{ display: 'inline-block' }}><strong>ถนน:</strong> {address['road']}&nbsp;</div>) : ''
            address.alley ? arrayAddress2.push(<div key={id++} style={{ display: 'inline-block' }}><strong>ซอย:</strong> {address['alley']}&nbsp;</div>) : ''
            arrayAddress3.push(<div key={id++} style={{ display: 'inline-block' }}><strong></strong> {address['district']}&nbsp;</div>)
            arrayAddress3.push(<div key={id++} style={{ display: 'inline-block' }}><strong></strong> {address['area']}&nbsp;</div>)
            arrayAddress3.push(<div key={id++} style={{ display: 'inline-block' }}><strong></strong> {address['province']}&nbsp;</div>)
            arrayAddress3.push(<div key={id++} style={{ display: 'inline-block' }}><strong></strong> {address['zip_code']}&nbsp;</div>)
            address.landmark ? arrayAddress4.push(<div key={id++} style={{ display: 'inline-block', color: '#163f09' }}><strong>จุดสังเกต:</strong> {address['landmark']}&nbsp;</div>) : ''
            return (
                <Row key={id++}>
                    <Col md={1} sm={12} xs={12} />
                    <Col md={11} sm={12} xs={12}>
                        <div>
                            {/* <div>{arrayAddress1}</div><br /> */}
                            <div>{arrayAddress2}</div><br /><div>{arrayAddress3}</div><br />{arrayAddress4}</div>
                    </Col>
                </Row>
            )
        })
    }
    renderEditAddress() {
        const { handleSubmit } = this.props
        return (
            <Panel>
                {this.renderEditAddressItem()}
                <Row>
                    <button style={{ marginRight: 10, width: 150, height: 35 }} className='btn btn-danger pull-right' onClick={() => { this.setState({ editAddress: false }); this.props.dispatch(reset('EditUserInfoForm')) }}>ยกเลิก</button>
                </Row>
            </Panel>
        )
    }
    renderEditAddressItem() {
        let id = 0
        return _.map(this.state.user.address, address => {
            // let key = address.split(/[\s,/]+/)
            // key = key[0]
            return (
                <div key={id++}>
                    <ComponentAddress lat={this.state.lat} lng={this.state.lng} setRegisterPageState={this.setRegisterPageState.bind(this)}
                        house_number={this.state.user.address.address1.house_number} road={this.state.user.address.address1.road}
                        landmark={this.state.user.address.address1.landmark} residential_type={this.state.user.address.address1.residential_type} />
                </div>
            )
        })
    }
    render() {
        // console.log('user', this.state.user)
        if (this.state.isLogin) {
            return (
                <div>
                    <NavHeader history={this.props.history} />
                    <SubMenu ref={d => this.submenu = d} history={this.props.history} />
                    <div className="container main-bg">
                        <Col md={2} sm={12} xs={12}>
                        </Col>
                        <Col md={8} sm={12} xs={12}>
                            <h3>ข้อมูลส่วนตัว</h3>
                            {!this.state.editInfo ? this.renderInfo() : this.renderEditInfo.call(this)}
                            {!this.state.editAddress ? this.renderAddress() : this.renderEditAddress()}
                            <button className='btn btn-success pull-right' onClick={() => this.onLogout()}>ออกจากระบบ</button>
                            {this.props.show_button == 'show' ? <button className='btn btn-success pull-right' style={{ marginRight: 5 }} onClick={() => { this.props.history.push('/order_review') }}>ทำรายการต่อไป</button> : ''}
                            <button className={this.props.payment_stage == 'confirm_address' ? 'btn btn-success pull-right' : 'hidden'} style={{ marginRight: 10 }} onClick={() => { this.props.history.push('/confirm_address') }}>กลับสู่หน้าเลือกวิธีจัดส่ง</button>
                            <br /><br />
                        </Col>
                        <Col md={2} sm={12} xs={12}>
                        </Col>
                        {/* Modal */}
                        <Modal show={this.state.showModal}>
                            <Modal.Header>
                                <Modal.Title>เพิ่มที่อยู่</Modal.Title>
                            </Modal.Header>
                            <Modal.Body >
                                {
                                    <textarea className="form-control" rows="2" id="address" placeholder='กรอกที่อยู่ใหม่'
                                        onChange={event => { this.textareaHandler(event) }} value={this.state.new_address} ></textarea>
                                }
                            </Modal.Body>
                            <Modal.Footer>
                                <Button bsStyle="danger" onClick={() => { this.closeModal() }}>ยกเลิก</Button>
                                <Button bsStyle="success" disabled={this.state.new_address ? false : true} onClick={() => {
                                    this.onFinishAddAddress()
                                }}>เพิ่ม</Button>
                            </Modal.Footer>
                        </Modal>
                        {/* Modal */}
                    </div>
                    <Footer history={this.props.history} />
                </div>
            )
        } else {
            return (
                <div className='container'>
                    <h1>loading...</h1>
                </div>
            )
        }
    }
}
function validate(values) {
    const errors = {}
    if (!values.phone_number) {
        errors.phone_number = 'กรุณาใส่เบอร์โทรศัพท์'
    }
    // if (!values.name_title) {
    //     errors.name_title = 'กรุณาใส่คำนำหน้าชื่อ'
    // }
    if (!values.name) {
        errors.name = 'กรุณาใส่ชื่อ'
    }
    if (!values.lastname) {
        errors.lastname = 'กรุณาใส่นามสกุล'
    }
    if (!values.residential_type) {
        errors.residential_type = 'กรุณาใส่ประเภทที่อยู่อาศัย'
    }
    if (!values.house_number) {
        errors.house_number = 'กรุณาใส่เลขที่บ้าน'
    }
    if (!values.zip_code) {
        errors.zip_code = 'กรุณาใส่รหัสไปรษณีย์'
    }
    if (!values.province) {
        errors.province = 'กรุณาใส่จังหวัด'
    }
    if (!values.district) {
        errors.district = 'กรุณาใส่แขวง'
    }
    if (!values.area) {
        errors.area = 'กรุณาใส่เขต'
    }
    return errors;
}
function mapStateToProps(state) {
    return {
        initialValues: state.edit_user_info_form_initial_reducer,
        payment_stage: state.payment_stage_reducer,
        show_button: state.button_user_info_page_reducer
    }
}
let InitializeEditUserInfoForm = reduxForm({
    form: 'EditUserInfoForm',
    validate,
    enableReinitialize: true
})(PageUserInfo)
InitializeEditUserInfoForm = connect(
    mapStateToProps,
    { fetchEditUserInfoFormInitial, updateAccount, showButtonUserInfoPage }
)(InitializeEditUserInfoForm)
export default InitializeEditUserInfoForm


// WEBPACK FOOTER //
// ./src/components/page_user_info.js